define([
    'componentsCore/utils/accessibility/tabbable/tabbable',
    'componentsCore/utils/accessibility/keyboardInteractions/keyboardInteractions'
], function (
    tabbable,
    keyboardInteractions
) {
    'use strict';

    return {
        getTabbaleElements: tabbable.getTabbableElements,
        keyboardInteractions
    };
});
